import axios from '@/libs/api.request'
import config from '@/config'

const baseCloudUrl = config.basePrivateCloudUrl
const privateCloudBaseUrl = baseCloudUrl + '/cloud/api/v1/'

export const getContentTypeId = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'get_content_type_id',
    params: params,
    method: 'get'
  })
}

export const getOperateLogs = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'operate_logs_list/',
    params: params,
    method: 'get'
  })
}

export const getCacheData = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'cache_data/',
    params: params,
    method: 'get'
  })
}
